// @ts-nocheck
import { Modal } from "antd";
import Button from "atoms/button/button";
import Icon from "atoms/icons/icon";
import Sheet from "atoms/sheet/sheet";
import SheetBody from "atoms/sheet/sheetBody/sheetBody";
import { isNewVersionAvailable } from "models/subscriptions/selector";
import { getWebAppSettings } from "models/user/selector";
import Stack from "molecules/stack/stack";
import StackItem from "molecules/stackItem/stackItem";
import React from "react";
import { useSelector } from "react-redux";
import "./updateBanner.css";

export const ReleaseVersion = (props) => {
  const isNewVersion = useSelector(isNewVersionAvailable);
  const { ReleaseVersion, isBlocking } = useSelector(getWebAppSettings);

  const getLatestVersion = () => {
    localStorage.setItem("releaseVersion", ReleaseVersion);
    window.location.reload(true);
  };

  const UpdateBanner = () => (
    <div className="update-banner">
      <div className="banner-content">
        <svg
          className="banner-icon"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0 1 1 0 002 0zm-.25 3.75c.414 0 .75.336.75.75v4a.75.75 0 01-1.5 0v-4c0-.414.336-.75.75-.75z" />
        </svg>

        <div className="banner-text">
          <span className="text-bold">Update Available</span>
          <span className="text-divider">|</span>
          <span>A new version of the application is ready to install.</span>
        </div>
      </div>

      <button className="banner-btn" onClick={getLatestVersion}>
        Update Now
      </button>
    </div>
  );

  return (
    <Stack isVertical>
      <StackItem className="new-version-btn">
        {ReleaseVersion && isNewVersion && (
          <>
            {/* BLOCKING UPDATE → FULL MODAL */}
            {isBlocking ? (
              <Modal centered visible closable={false} maskClosable={false} footer={null}>
                <Sheet>
                  <SheetBody>
                    <Stack
                      isVertical
                      gutter="medium"
                      align="center"
                      position="center"
                    >
                      <StackItem>
                        <Icon imgAlias="ThetaLogoDark" size="large" />
                      </StackItem>

                      <StackItem>
                        <UpdateBanner />
                      </StackItem>
                    </Stack>
                  </SheetBody>
                </Sheet>
              </Modal>
            ) : (
              <div className="mb-2 w-100">
                <UpdateBanner />
              </div>
            )}
          </>
        )}
      </StackItem>

      {/* Hide main app content if blocking update */}
      <StackItem isGrow isHidden>
        {isNewVersion && isBlocking ? null : props.children}
      </StackItem>
    </Stack>
  );
};
